import { FlashList } from '@shopify/flash-list';
import { Box, Flex, useBreakpointValue } from 'native-base';
import React, { ReactNode, useMemo } from 'react';

import { NoContentContainer } from '~/components/no-content-container';
import { Spacing } from '~/components/spacing';
import { SystemMessage } from '~/components/system-message';

type Props<T> = {
    items: readonly T[];
    renderItem: (item: T) => ReactNode;
    noContentMessage?: string;
    customColumnCount?: number;
    minCardHeight?: number;
    minCardWidth?: number;
};

export const MasonryList = <T,>(props: Props<T>) => {
    const { items, noContentMessage, renderItem, customColumnCount } = props;

    const breakpointColumnCount = useBreakpointValue({
        base: 1,
        md: 2,
        lg: 3
    });

    const columnsCount = useMemo((): number => {
        if (customColumnCount && customColumnCount < 4) {
            return customColumnCount;
        } else {
            return breakpointColumnCount;
        }
    }, [breakpointColumnCount, customColumnCount]);

    return (
        <FlashList
            key={`${columnsCount}`}
            keyExtractor={(_item: T, index: number) => `${index}`}
            scrollEnabled={false}
            masonry
            data={items as T[]}
            numColumns={columnsCount}
            renderItem={({ item }: { item: T }) => <Box m="2">{renderItem(item)}</Box>}
            ListEmptyComponent={
                <Flex>
                    <NoContentContainer>
                        <Spacing.Vertical.SMALL />
                        <SystemMessage label={noContentMessage ?? '-'} />
                    </NoContentContainer>
                </Flex>
            }
        />
    );
};
